import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

interface PublicOnlyGuardProps {
  children: React.ReactNode;
}

export function PublicOnlyGuard({ children }: PublicOnlyGuardProps) {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
}
